// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters[data-v-15f22d6f] {\n  word-wrap: break-word;\n}\n.filters ul[data-v-15f22d6f] {\n  padding-left: 0;\n}\n.filters ul li[data-v-15f22d6f] {\n  list-style: none;\n}\n", ""]);
// Exports
module.exports = exports;
